import { render, staticRenderFns } from "./creatTemplates.vue?vue&type=template&id=1ff8ff4a&scoped=true"
import script from "./creatTemplates.vue?vue&type=script&lang=js"
export * from "./creatTemplates.vue?vue&type=script&lang=js"
import style0 from "./creatTemplates.vue?vue&type=style&index=0&id=1ff8ff4a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff8ff4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ff8ff4a')) {
      api.createRecord('1ff8ff4a', component.options)
    } else {
      api.reload('1ff8ff4a', component.options)
    }
    module.hot.accept("./creatTemplates.vue?vue&type=template&id=1ff8ff4a&scoped=true", function () {
      api.rerender('1ff8ff4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rsManagement/expressSetting/components/creatTemplates.vue"
export default component.exports